module.exports = __webpack_public_path__ + "static/cryptoreference-2e9e88e664de43973977d8d78e1fc6c8.png";